// Ported from LC2 (src/commons/components/HomeTabs/Esg/EsgTab.js) — lazy account-level ESG
// fetch, gated on `dashboardAccount` having a real (non-'all') sfid. `esg/?account_id=...`
// (see metricsSlice.js's getAccountESG) returns the same {first_block, second_block,
// third_block, is_esg_enabled} contract as current LC. It is account-scoped only — no
// confirmed per-community variant — so this always shows the same account-wide report no
// matter which community is selected via the header breadcrumb; LC2's separate
// community-level ESG fetch (esg_dashboard/property/{sfid}/) has been dropped for that
// reason. Visual layer matches
// the actual Figma "Dashboard-Body" frame (node 18158:8610): each block renders as its own
// bordered card, so this no longer wraps everything in one outer Box — see EsgComponent.js
// in this folder for the content/layout.
import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';

import EsgComponent from './EsgComponent';
import {getDashboardAccount} from '../../../app/store/reducers/dashboard';
import {useLazyGetAccountESGQuery} from '../../../features/coreApi/metricsSlice';

const EsgSection = () => {
    const dashboardAccount = useSelector(getDashboardAccount);

    const [
        fetchAccountsEsg,
        {data: accountEsg = {}, isLoading: isAccountEsgLoading, isFetching: isAccountEsgFetching, isSuccess: isAccountEsgSuccess}
    ] = useLazyGetAccountESGQuery();

    useEffect(() => {
        if (dashboardAccount.sfid && dashboardAccount.sfid !== 'all') {
            fetchAccountsEsg({sfid: dashboardAccount.sfid});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dashboardAccount]);

    return <EsgComponent data={accountEsg} isLoading={isAccountEsgFetching || isAccountEsgLoading} isSuccess={isAccountEsgSuccess} />;
};

export default EsgSection;
